// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__30Epr","resendInfoText":"OnGoingPaymentBox_resendInfoText__1yO0X"};